import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {JOB_SHIPPING_CARRIER} from "../../../helper/jobFilter"

class ShippingCarrier extends Component {
    render() {
        const {shippingCarrier} = this.props
        const carrier = JOB_SHIPPING_CARRIER.find(job => job.value === shippingCarrier)

        return (
            <td className="ShippingCarrier">
                {!!carrier && carrier.name}
            </td>
        )
    }
}

ShippingCarrier.propTypes = {
    shippingCarrier: PropTypes.string
}

export default ShippingCarrier